import React, { useEffect, useRef, useState, IonLoading } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { Helmet } from 'react-helmet';
import { ApiService } from '../../containers/Services/apiservice';
import { Watch } from "react-loader-spinner";

let apiServices = new ApiService();

const Blog = () => {
  const [blogsData, setBlogsData] = useState([]);
  const [baseUrl, setBaseUrl] = useState('');
  const [spinnerLoading, setSpinnerLoading] = useState(false);

  const didMountRef = useRef(true);
  useEffect(() => {
    if (didMountRef.current) {
      setSpinnerLoading(true);
      apiServices.blogGetRequest()
        .then(res => {
          if (res.data.status == 'success') {
            setBlogsData(res.data.data);
            setBaseUrl(res.data.baseurl);
            setSpinnerLoading(false);
          }
        })
    }
    didMountRef.current = false;
  }, []);
  return (
    <div>
      <Header />
      <Helmet>
        <title>Goalstox</title>
        <meta name="keywords" content="HTML, CSS, JavaScript" />
        <meta name="description" content="test on react-helmet" />
      </Helmet>
      <section>
        <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
          <div className='overlay-box'>
            <Watch
              color="#ffffff"
              visible={spinnerLoading}
            />
          </div>
        </div>
        <div className="container-fluid">
          <div className="section-title tx-center">
            <h2>Keep Learning, Keep Growing</h2>
            <p>Keeping your investment portfolio simple, diversified, and sticking to your asset allocation is more important than trying to pick individual winning stocks. Your investment risk profile is more important than trying to catch every fancy investment product. Keep it simple.</p>
          </div>
          <div className="row">
            {
              blogsData.map(key =>
                <div className="col-md-4" >
                  <div className="blogbox">
                    <div className="blogbox-img">
                      <Link to={`/blog-detail/${key.blog_slug}`}>
                        {
                          key.blog_image != '' ? <img src={baseUrl + key.blog_image} /> : <img src="https://www.codexocoder.com/2022/goalstox/public/img/uploads/blog_image/1649328888.webp" />
                        }
                      </Link>
                    </div>
                    <div className="blog-meta">
                      <div className="blog-meta-date">{key.datetime} | by Goalstox</div>
                      <div className="blog-meta-category">
                        <ul>
                          {
                            key.blog_category_id.map(cat => <li><Link to={`/blog-category/${cat.category_slug}`}>{cat.category_name}</Link></li>)
                          }
                       </ul>
                      </div>
                    </div>
                    <div className="blogbox-title">{key.blog_name}</div>
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
export default Blog;